import GooFeatures from "./goo-features";

export default function install(Vue, options = {}) {
    Vue.prototype.$flags = GooFeatures;
}

export {
    GooFeatures,
}
